import {Route, Switch} from "react-router-dom";
import ListStores from "./ListStores";
import PageStore from "./PageStore";
import {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {FETCH_STORES} from "../../../../redux/types/stores.types";

const Stores = () => {
    const dispatch = useDispatch();
    const {token, activeAddress} = useSelector(state => state.user);
    const {address: guestAddress} = useSelector(state => state.guest);
    const {storeSelected} = useSelector(state => state.shoppingCart);

    useEffect(() => {
        /*اجرای متد دریافت اطلاعات دسته بندیی ها و فروشگاه انتخاب شده*/
        dispatch({type: FETCH_STORES, payload: {token, activeAddress, guestAddress, storeSelected}});
        // eslint-disable-next-line
    }, [token, activeAddress]);

    return (
        <Switch>
            <Route exact path={'/stores'} component={ListStores}/>
            <Route path={'/stores/:store'} component={PageStore}/>
        </Switch>
    );
}

export default Stores;
